module.exports = __webpack_public_path__ + "img/avatar2.dabe39d2.png";